import { FileTextIcon, DownloadIcon, ActivityIcon, SmartphoneIcon } from 'lucide-react';

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/8d2Km6uK3YbCyE8xs73iAT/Coleccion_de_Guias_de_Triatlon_SIGMA_SMART.webp';

export const heroChips = [
  { icon: FileTextIcon, label: '100% Görsel PDF' },
  { icon: DownloadIcon, label: 'Anında İndirme' },
  { icon: ActivityIcon, label: 'Tüm Eğitim Seviyeleri' },
  { icon: SmartphoneIcon, label: 'Android ve iOS' },
];

export const disciplines = ['Yüzme', 'Bisiklet', 'Koşu', 'Beslenme', 'İlerleme takibi', 'Yarış günü uygulaması'];
